var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lDfault',{attrs:{"title":"礼品卡"}},[_c('GiftCardList'),_c('van-cell',{staticClass:"mg-t",attrs:{"title":"激活礼品卡","is-link":"","to":"activateGiftCard"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }